import {FIELD_TYPE} from "types/enums";
import {DataFormField} from "types/models/input-field-type";
import {ColumnsEdit} from "../../../../../../../../../types/models/column-table-edit";
const {INPUT, SELECT, DATE, COLOR ,COMBO_BOX} = FIELD_TYPE;
const css = { xs: 24, sm: 24, md: 24, lg: 8, xl: 8 };
const dataFields: ColumnsEdit = [
  {
    type: INPUT,
    label: "Mã loại",
    name: "maLoai",
    rules: [{required: true, message: "Chưa nhập mã loại hợp đồng"}],
    css:css,
    wrapperCol: { xs: 24,sm:14, md: 14, lg: 18, xl: 18 },
    labelCol: { xs: 24,sm:10, md: 10, lg: 6, xl: 6},
  },
  {
    type: INPUT,
    label: "Tên loại",
    name: "tenLoai",

    rules: [{required: true, message: "Chưa nhập tên loại hợp đồng"}],
    css:css,
    wrapperCol: { xs: 24,sm:14, md: 14, lg: 18, xl: 18 },
    labelCol: { xs: 24,sm:10, md: 10, lg: 6, xl: 6},
  },
  {
    type: COMBO_BOX,
    label: "Mã cấu hình nghỉ phép",
    name: "idNgayNghiPhep",
    rules: [{required: true, message: "Chưa nhập mã nghỉ phép"}],
    css:css,
    wrapperCol: { xs: 24,sm:14, md: 14, lg: 14, xl: 14 },
    labelCol: { xs: 24,sm:10, md: 10, lg: 10, xl: 10},
  },
  {
    type: INPUT,
    label: "Ghi chú",
    name: "ghiChu",
    css:css,
    wrapperCol: { xs: 24,sm:14, md: 14, lg: 18, xl: 18 },
    labelCol: { xs: 24,sm:10, md: 10, lg: 6, xl: 6},
  },
];
export {dataFields};
